<template>
  <div>
    <ReportSection
      :columns="3"
      data-test-id="ValueReport_efficiencyCard"
      title="Efficiency"
    >
      <Stat
        v-for="(data, index) in metrics"
        :key="`efficiency-stat-${index}`"
        :metric="data"
      />
    </ReportSection>
    <Card
      :class="$style.card"
    >
      <template v-slot:body>
        <div
          data-test-id="ValueReport_timeSavingsChart"
        >
          <TimeSavingsChart
            :companyHoursPerUser="companyActivateTimePerUser"
            :industryHoursPerUser="industryActivateTimePerUser"
            :infoText="activatedInfoText"
            :metricTotal="totalActivated"
            noDataMessage="No activations this period."
            subTitle="
            Activating includes the creation of identities and granting access to resources.
          "
            title="Time saved activating users"
          />
          <TimeSavingsChart
            :companyHoursPerUser="companySuspendTimePerUser"
            :industryHoursPerUser="industrySuspendTimePerUser"
            :infoText="suspendInfoText"
            :metricTotal="totalSuspended"
            noBorder
            noDataMessage="No suspensions this period."
            subTitle="
            Suspending includes revoking access to resources and deactivating identities.
          "
            title="Time saved suspending users"
          />
        </div>
      </template>
    </Card>
    <div :class="$style.info">
      <Icon
        :class="$style.icon"
        icon="info"
        :scale="1"
      />
      <ParagraphBody>
        We've discussed these metrics with other IT admins just like you to arrive at an average.
        We'd love it if you could please help us increase our accuracy by completing a
        <Link
          href="https://www.surveymonkey.com/r/DY9XF6M"
          isExternal
          text="quick survey"
        />.
      </ParagraphBody>
    </div>
  </div>
</template>

<script>
import {
  Card,
  Icon,
  Link,
  ParagraphBody,
} from '@jumpcloud/ui-components';

import ReportSection from './ReportSection.vue';
import Stat from './Stat.vue';
import TimeSavingsChart from './TimeSavingsChart.vue';

export default {
  name: 'EfficiencyCard',

  components: {
    Card,
    Icon,
    Link,
    ParagraphBody,
    ReportSection,
    Stat,
    TimeSavingsChart,
  },

  props: {
    metrics: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      companyActivateTimePerUser: 1,
      industryActivateTimePerUser: 2,
      companySuspendTimePerUser: 1,
      industrySuspendTimePerUser: 2,
    };
  },

  computed: {
    activatedInfoText() {
      return `Based on JumpCloud's activation time of ${this.companyActivateTimePerUser} hour per user.\
       You've activated ${this.totalActivated} users.`;
    },

    suspendInfoText() {
      return `Based on JumpCloud's suspending time of ${this.companyActivateTimePerUser} hour per user.\
       You've suspended ${this.totalSuspended} users.`;
    },

    totalActivated() {
      const activations = this.metrics.find(metric => metric.label === 'Total Users Activated');
      return activations ? activations.value : -1;
    },

    totalSuspended() {
      const suspensions = this.metrics.find(metric => metric.label === 'Total Users Suspended');
      return suspensions ? suspensions.value : -1;
    },
  },
};
</script>

<style module scoped>
  .card.card {
    background-color: transparent;
    border-color: var(--jcInformational);
    border-width: var(--jc-border-width-double);
  }

  .card.card,
  .info {
    margin: var(--jc-spacer-medium) var(--jc-spacer-medium) 0;
  }

  .info {
    display: flex;
  }

  .icon.icon {
    color: var(--jc-color-neutral-text-subdued);
    line-height: 1.8;
    margin-right: var(--jc-spacer-small);
  }
</style>
